module.exports = __webpack_public_path__ + "img/deactivate_user-icon.296a3070.svg";